"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CityTime = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Icon_1 = require("../../Icon");
require("./index.scss");
const className = 'city-time';
class CityTime extends react_1.default.PureComponent {
    render() {
        const { cityStart, cityEnd, timeStart, timeEnd, duration, modificators } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__row` },
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement("div", { className: `${className}__city` }, cityStart),
                    react_1.default.createElement("div", { className: `${className}__time` }, timeStart)),
                react_1.default.createElement("div", { className: `${className}__icon` },
                    react_1.default.createElement(Icon_1.Icon, { name: 'airplane-horisontal' })),
                react_1.default.createElement("div", { className: `${className}__column` },
                    react_1.default.createElement("div", { className: `${className}__city` }, cityEnd),
                    react_1.default.createElement("div", { className: `${className}__time` }, timeEnd))),
            react_1.default.createElement("div", { className: `${className}__duration` },
                react_1.default.createElement("span", { className: `${className}__duration-title` },
                    react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/CityTime:TravelTime', defaultMessage: 'Travel time:' })),
                react_1.default.createElement("span", { className: `${className}__duration-value` }, duration))));
    }
}
exports.CityTime = CityTime;
CityTime.defaultProps = {
    cityStart: null,
    cityEnd: null,
    timeStart: null,
    timeEnd: null,
    duration: null,
};
//# sourceMappingURL=index.js.map